import store from 'shared/store'

import {
  changeVisibilitySubscriptionElements,
  getSubscriptionElements
} from './helpers'

export * from './helpers'
export default userSession => {
  const { subscriptionService, isLoggedIn } = userSession || {}
  const {
    pageProperties: { isSubscriptionProduct, productStockStatus }
  } = store.getPublicRuntimeConfig()
  const {
    buyboxSubscriptionLink,
    buyboxPersonalAdviceLink,
    productDescriptionPersonalAdviceLink,
    productLabelAboElement,
    headerAboLink
  } = getSubscriptionElements()

  changeVisibilitySubscriptionElements({
    buyboxSubscriptionLink,
    buyboxPersonalAdviceLink,
    productDescriptionPersonalAdviceLink,
    subscriptionService,
    isSubscriptionProduct,
    productStockStatus,
    productLabelAboElement,
    headerAboLink,
    isLoggedIn
  })
}
